// extracted by mini-css-extract-plugin
export var resizer = "_gt-0";